import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24",
  fill: "#F0EBFB",
  rx: "12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#4C4DEE",
  d: "M12 19.556a1.7 1.7 0 0 1-.57-.1 1.3 1.3 0 0 1-.51-.32l-1.38-1.26a55 55 0 0 1-3.83-3.85Q4 12.116 4 9.816q0-1.88 1.26-3.14t3.14-1.26q1.06 0 2 .45t1.6 1.23q.66-.78 1.6-1.23t2-.45q1.88 0 3.14 1.26T20 9.816q0 2.3-1.7 4.22a48 48 0 0 1-3.86 3.86l-1.36 1.24a1.3 1.3 0 0 1-.51.32 1.7 1.7 0 0 1-.57.1"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }